import React from 'react';
import {
  TabContent, StoreFooter,CartBtn
} from './ThemeLayoutHelpers';


export default function ArtisanLayout({ p }) {
  const T = p.storeTheme || {};
  // const primary = T.primaryColor || "#b45309";
  return (
    <div className="min-h-screen flex flex-col bg-amber-50" style={{ ...p.themeStyles, fontFamily: T.fontFamily || "Lora, serif" }}>
      <nav className="sticky top-0 z-40 bg-amber-100 border-b border-amber-300">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <p className="font-bold">{p.storeInfo?.businessName}</p>
          <CartBtn p={p} />
        </div>
      </nav>
      <div className="max-w-7xl mx-auto w-full px-4 py-6"><TabContent p={p} /></div>
      <StoreFooter p={p} />
    </div>
  );
}